import moment from "moment";
import { VariablesConstant } from "../../constants/variables";

export default function ConnectionNotiItem(props: any) {
  return (
    <>
      <div className="me-2">{moment(props.createdDt).format("YYYY/MM/DD, HH:mm:ss")}</div>
      {props.notiTp === VariablesConstant.COLLECTION_INSTANCE_STOPPED && (
        <span>
          <b>Collection instance</b> of connection has stopped.
        </span>
      )}
      {props.notiTp === VariablesConstant.DELIVERY_INSTANCE_STOPPED && (
        <span>
          <b>Delivery instance</b> of connection has stopped.
        </span>
      )}
      {props.notiTp === VariablesConstant.COLLECTION_CONNECT_KAFKA_FAILED && (
        <span>
          <b>Collection instance</b> of connection can't connect to kafka.
        </span>
      )}
      {props.notiTp === VariablesConstant.DELIVERY_CONNECT_KAFKA_FAILED && (
        <span>
          <b>Delivery instance</b> of connection can't connect to kafka.
        </span>
      )}
      {props.notiTp === VariablesConstant.COLLECTION_DEVICE_STOPPED && (
        <span>
          <b>Collection instance</b> of connection can't connect to device.
        </span>
      )}
      {props.notiTp === VariablesConstant.DELIVERY_CONNECT_DATABASE_FAILED && (
        <span>
          <b>Delivery instance</b> of connection can't connect to database.
        </span>
      )}
    </>
  );
}
